import * as React from 'react';

import {PaginationControlsBar} from '../pagination-controls-bar/pagination-controls-bar';

import styles from './paginated-table-control-bar.module.css';

type Props = {
    currentPage: number;
    totalCount: number;
    onPageChange: (arg1: number) => any;
    disableButtons?: boolean;
    pageSize: number;
    buttons?: React.ReactNode;
};

export function PaginatedTableControlBar(props: Props) {
    const totalPages = Math.ceil(props.totalCount / props.pageSize);

    return (
        <div className={styles.container}>
            <PaginationControlsBar
                collectionLength={props.totalCount}
                currentPage={props.currentPage}
                pageSize={props.pageSize}
                totalPages={totalPages}
                onPageChange={props.onPageChange}
                disableButtons={props.disableButtons}
            />
            {props.buttons}
        </div>
    );
}
